import gsap from 'gsap';
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export function animateHeroTitle() {
    gsap.to('.hero-type-1-section .onlyFade', {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        delay: 0.3,
        duration: 1
    })
}

export function animateHeroDescription() {
    gsap.to('.hero-type-1-section .description', {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        delay: 0.6,
        duration: 1
    })
}

export function animateButton() {
    const activeLink = document.querySelector('.hero-type-1-section .btn-magnet');

    if (!activeLink) {
        return false
    }

    gsap.timeline()
        .add(() => {
            activeLink.classList.add('show')
        }, '<0.5')
        .to(activeLink, {}, '>1')
}

export function initScrollAnchorButton() {
    const buttons = document.querySelectorAll('.scroll-down');
    buttons.forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const nextSectionTop = btn.closest('section').nextElementSibling.offsetTop;

            gsap.to(window, {
                duration: 1.2,
                scrollTo: {
                    y: nextSectionTop,
                    offsetY: 65
                }
            });
        })
    });
}